// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    // suggestionMobileStyle: 'style2',
    suggestionDelay: 500
  }
};


(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {
    
    
    
    
  };
  
  var bindEvents = InstantSearchMobile.prototype.bindEvents;
  
  InstantSearchMobile.prototype.bindEvents = function() {
      bindEvents.call(this);

      var self = this;
    
    if(Utils.isMobile()){
      jQ('.boost-search-header').off('click').click(function(e) {
        e.preventDefault();
        e.stopPropagation();        
        self.openSuggestionMobile()
      });
    }
      
  }
  
  InstantSearchMobile.prototype.afterShowSearchBoxMobile = function() {
  }
  
  var instantSearchInit = InstantSearch.prototype.init;

  InstantSearch.prototype.init = function() {  
    jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]').each(function(i) {
      if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
        var clone = jQ(this).clone();
        jQ(this).replaceWith(clone);
      }
    });

    instantSearchInit.call(this);
  }
  
//   document.addEventListener("DOMContentLoaded", function(event) {
//     if(Utils.isMobile()){
//       jQ('.js-search-header').addClass('boost-search-header').removeClass('js-search-header');
      
//     }
//   });
  
//   var intervalBoost = setInterval(function() {
//     if(document.readyState === 'complete') {
//         clearInterval(intervalBoost);
       
//         if(Utils.isMobile()){
//           jQ('.js-search-header').addClass('boost-search-header').removeClass('js-search-header');
//         }
      
//     }    
// }, 100);
  
  
var originalcloseInstantSearchMobile = InstantSearchMobile.prototype.closeInstantSearchMobile;
InstantSearchMobile.prototype.closeInstantSearchMobile = function(isClose) {
	// Call the original function in our app lib.
	// We don't have to copy a very big function out here to modify.
	// function.call(this, param1, param2) binds the "this" pointer and params to the original function.
	originalcloseInstantSearchMobile.call(this, isClose);

	// Do your custom code after the original function has run
  jQ('.js-search-header-close').click();
}

/* Boost #51357 - For the pop-up magnifier - Oct 28, 21:11 */
jQ(document).mouseup(function(e) {
  var container = jQ("#HeaderSearchForm .site-header__search-input");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0)  {
    jQ('.site-header__search-container').removeClass('is-active');
  }
});
  
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
    // If the multi-currency feature is enabled, update the product price
    this.prepareSuggestionProductPriceData();
    // Check on sale
    var onSale = this.data.compare_at_price_min > this.data.price_min;
    // Format price
    var price = Utils.formatMoney(this.data.price_min);
    var compareAtPrice = '';
    if (this.data && this.data.compare_at_price_min) {
      compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
//       if (Settings.getSettingValue('search.removePriceDecimal')) {
//         price = Utils.removeDecimal(price);
//         compareAtPrice = Utils.removeDecimal(compareAtPrice);
//       }
    }

    // Build Price
    var result = '';
    if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
      if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
      } else {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
      }
    }
    
    if (this.data.price_min == 0 && this.data.price_max == 0) {
      price = '';
    } else {
      var prices = this.data.variants.map(function(e) {return parseFloat(e.price);});
      prices = prices.sort();
      if (prices[0] > 0) {
        price = Utils.formatMoney(prices[0]);
      } else {
        price = Utils.formatMoney(prices[1]);
      }
    }
    return result
    .replace(/{{regularPrice}}/g, price)
    .replace(/{{compareAtPrice}}/g, compareAtPrice);
  }
  
})();

